import { Square } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const StopIcon = DeckardIconWrapper({ Icon: Square });
